import { Component, Input } from "@angular/core"
import { UserService } from "../../../../services/user.service"

@Component({
    selector: "app-resource-card-poster",
    templateUrl: "./resource-card-poster.component.html",
    styleUrls: ["./resource-card-poster.component.scss"],
})
export class ResourceCardPosterComponent {
    @Input() public posterImage = null
    @Input() public link = null
    @Input() public alt = null
    @Input() public duration = null
    @Input() public isInline: boolean = false
    @Input() public gtmPrefix: string = ""
    @Input() public absoluteUrl: string = ""
    @Input() public title: string = null
    @Input() public mediaType: string = ""
    @Input() public gtmDataCardNumber: number
    public placeholderImg: string = null

    constructor(public userService: UserService) {
        this.placeholderImg = require("../../../../../assets/placeholder-image.svg").default
    }

    public getFormattedDuration(): string {
        return ResourceCardPosterComponent.formatDuration(this.duration)
    }

    public static formatDuration(duration): string {
        if (!duration) {
            return null
        }
        if (duration.substring(0, 2) === "0:") {
            duration = duration.substring(2)
        }
        if (duration && duration[0] === "0") {
            duration = duration.substring(1)
        }
        return duration
    }

    public getResourcePosterClass() {
        if (this.gtmPrefix === "gtm-results-search-card") {
            return `card-header-content gtm-results-search-card`
        } else if (this.gtmPrefix === "gtm-results-browse-card") {
            return `card-header-content gtm-results-browse-card`
        }

        return `card-header-content gtm-${this.gtmPrefix}-resource-poster`
    }
}
